import { memo } from 'react';
import TextInfoItem from './TextInfoItem';
import QualityScoreInfoItem from './QualityScoreInfoItem';
import SpeechProportionInfoItem from './SpeechProportionInfoItem';

import type { CallKeyInfoItemConfig } from './CallKeyInfo';

interface CallKeyInfoItemProps {
    item: CallKeyInfoItemConfig;
}

/**
 * Renders the appropriate info item component based on item type.
 *
 * @param {CallKeyInfoItemProps} props
 * @returns {JSX.Element|null}
 **/
const CallKeyInfoItem: React.FC<CallKeyInfoItemProps> = ({ item }) => {
    switch (item.type) {
        case 'qualityScore':
            return <QualityScoreInfoItem label={item.label} labelId={item.labelId} score={item.score} />;
        case 'text':
            return <TextInfoItem label={item.label} labelId={item.labelId} value={item.value} />;
        case 'speechProportion':
            return <SpeechProportionInfoItem label={item.label} labelId={item.labelId} proportion={item.proportion} />;
        default:
            return null;
    }
};

export default memo(CallKeyInfoItem);
